import qs from "qs";

import i18n from "components/i18n/source";

export default class BaseApi {
  /**
   * Perform an HTTP get
   *
   * @param {string} path
   * @param {object} params
   * @returns {Promise<Response>} see: https://developer.mozilla.org/en-US/docs/Web/API/Response
   */
  static get(path, params = {}) {
    return fetch(queryString(path, params), baseOptions());
  }

  /**
   * Perform an HTTP post
   *
   * @param {string} path
   * @param {object} body
   * @returns {Promise<Response>} see: https://developer.mozilla.org/en-US/docs/Web/API/Response
   */
  static post(path, body = {}, options = {}) {
    return fetch(
      path,
      buildOptions({
        method: "POST",
        body: JSON.stringify(body),
        ...options,
      }),
    );
  }

  /**
   * Perform an HTTP patch
   *
   * @param {string} path
   * @param {object} body
   * @returns {Promise<Response>} see: https://developer.mozilla.org/en-US/docs/Web/API/Response
   */
  static patch(path, body = {}) {
    return fetch(
      path,
      buildOptions({
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    );
  }

  /**
   * Perform an HTTP put
   *
   * @param {string} path
   * @param {object} body
   * @returns {Promise<Response>} see: https://developer.mozilla.org/en-US/docs/Web/API/Response
   */
  static put(path, body = {}) {
    return fetch(
      path,
      buildOptions({
        method: "PUT",
        body: JSON.stringify(body),
      }),
    );
  }

  /**
   * Perform an HTTP delete
   *
   * @param {string} path
   * @returns {Promise<Response>} see: https://developer.mozilla.org/en-US/docs/Web/API/Response
   */
  static delete(path) {
    return fetch(
      path,
      buildOptions({
        method: "DELETE",
      }),
    );
  }
}

function buildOptions({ headers = {}, ...extraOptions }) {
  return Object.assign({}, baseOptions({ headers }), extraOptions);
}

function baseOptions({ headers: extraHeaders = {} } = {}) {
  return {
    headers: headers(extraHeaders),
    credentials: "include",
  };
}

function headers(extraHeaders = {}) {
  return new Headers({
    "X-CSRF-Token": csrfToken(),
    "X-Anonymous-Id": anonymousId(),
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": i18n.language,
    ...extraHeaders,
  });
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || "";
}

export function csrfParam() {
  return document.querySelector('meta[name="csrf-param"]')?.content || "";
}

export function anonymousId() {
  return document.querySelector('meta[name="anonymous-id"]')?.content || "";
}

function queryString(path, object) {
  return `${path}?${qs.stringify(object, { arrayFormat: "brackets" })}`;
}
